import self from "../images/yiju miller painting on-location.jpg"
import "../css/biography.css"

export default function Biography() {
  return (
    <div>
      <img src={self} alt="YiJu Miller" className="image" />
      <br />
      <p>YiJu is a member of Northwest Watercolor Society, Mt Si Artist Guild, and collective member of Snoqualmie Art Gallery.   
        She is also associated with a couple of plein air groups here in Washington. 
      </p>YiJu’s Art works have been shown in various locations including many Era Living shows, Overlake hospital, 
      Magnuson Park Gallery, Snoqualmie City Hall, Parklane Gallery, Art Gallery of SnoValley, and Cole Gallery.
      <br />
      <p>YiJu Statement:</p>
      <p>"I love painting on location; it gives me a sense of movement, atmosphere and connections with people and 
        the locations where I am painting. Plein air with watercolor has been fun with many challenges, but at the same time very rewarding. "
      </p>
      <div className="works-list">
        <h3>List of works:</h3>
        <ul>
          <li>2018
            <ul>
              <li>"Boy and Birds" was award 1st place for All Creatures Great and Small in Parklane Gallery.</li>
            </ul>
          </li>
          <li>2019
            <ul>
              <li>"Girl and Birds" was selected for the resident award for Era-living show.</li>
              <li>"Pet Duck" has won an honorable mention for Parklane Galley Winter Show.</li>
            </ul>
          </li>
          <li>2021
            <ul>
              <li>"Seattle Fisherman's Terminal" and "Twin Falls Trail" were selected to Plein Air Views of Washington show in Magnuson Park Gallery.</li>
            </ul>
          </li>
          <li>2022
            <ul>
              <li>"GasWorks Park" was selected to Plein Air Views of Washington.</li>
              <li>"Steam Train 924" won 2nd place in Snoqualmie Days Plein Air Paint Out and sold to City of Snoqualmie.</li>
              <li>Selected to participate in plein air event in Edmonds by Cole Galley.</li>
              <li>"Georgetown Seattle" was selected for 42nd Annual Arts of the Terrace Juried Art Show.</li>
              <li>“Chinese Garden” has been selected IWS India Plein Air Contest</li>
            </ul>
          </li>
          <li>2023
            <ul>
              <li>Officially a collective member of Art Gallery of SnoValley</li>
              <li>YiJu is the first demo artist participated in Fall fund raise event of Pacific  Bonsai Museum. 
                She donated the painting “Mediation” to help fund raising at lPacific Bonsai 2023 Branch out event.</li>
              <li>Selected to participate in plein air event in Edmonds by Cole Galley.</li>
              <li>Accepted to be the member of  Snoqualmie Art Commission</li>
              <li>"Golden Mantle Squarel" was accepted to Gallery North in Edmonds Jury Show</li>
              </ul>
          </li>
          <li>2024
            <ul>
              <li>Assisted and organized small work Jury show in Art gallery of Snovalley</li>
              <li>“Seattle Fishermen's Terminal” was accepted to NWWS 2024 international contest</li>
              <li>Organize free community art class with KCLS and city of Snoqualmie </li>
              <li>Accepted to be the member of  Snoqualmie Art Commission</li>
              <li>Solo exhibition in Snoqualmie city hall</li>
              </ul>
          </li>
        </ul>
      </div>
    </div>
  );
}
